module.exports = __webpack_public_path__ + "viasat-motor-530e789258635c165b602a41422d4054.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/logos/viasat-motor.jpg
// module id = 1158
// module chunks = 0 1